import { useEffect } from 'react';
import { setAppIdentifier, setBaseURL, setCustomerSecretKey, setTokenKey, } from '@/config/axios.config';
import { useConfigContext } from '@/hoc';
export var useSetAxiosConfig = function () {
    var _a = useConfigContext().config, apiBaseUrl = _a.apiBaseUrl, tokenKey = _a.tokenKey, appIdentifier = _a.appIdentifier, customerSecretKey = _a.customerSecretKey;
    useEffect(function () {
        setBaseURL(apiBaseUrl);
    }, [apiBaseUrl]);
    useEffect(function () {
        setTokenKey(tokenKey);
    }, [tokenKey]);
    useEffect(function () {
        setAppIdentifier(appIdentifier);
    }, [appIdentifier]);
    useEffect(function () {
        setCustomerSecretKey(customerSecretKey);
    }, [customerSecretKey]);
};
